import { Link, NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";

import Icon from "./Icon";
import Badge from "./Badge";
import { convertRoleToPath, userRoleItems } from "../utils/enum";

const Sidebar = ({ sidebarActive, mobileMenu, mobileMenuControl }) => {
  const auth = useSelector((state) => state.auth);

  const [menu, setMenu] = useState([]);

  const admin = [
    {
      heading: "خانه",
    },
    {
      icon: "solar:home-smile-angle-broken",
      text: "خانه",
    },
    {
      heading: "مدیریت",
    },
    {
      icon: "solar:users-group-two-rounded-broken",
      text: "کاربران",
      link: "/users",
    },
    {
      icon: "solar:reorder-broken",
      text: "سفارشات",
      link: "/admin/orders",
    },
  ];
  const courier = [
    {
      heading: "خانه",
    },
    {
      icon: "solar:home-smile-angle-broken",
      text: "خانه",
    },
    {
      heading: "مدیریت",
    },
    {
      icon: "solar:reorder-broken",
      text: "سفارشات",
      link: "/orders",
    },
  ];
  const customer = [
    {
      heading: "خانه",
    },
    {
      icon: "solar:home-smile-angle-broken",
      text: "خانه",
    },
    {
      heading: "مدیریت",
    },
    {
      icon: "solar:reorder-broken",
      text: "سفارشات",
      link: "/orders",
    },
  ];

  const filterMenuItems = (menuItems) => {
    return menuItems
      .map((menu) => {
        if (menu.subMenu) {
          const filteredSubMenu = filterMenuItems(menu.subMenu);
          menu.subMenu = filteredSubMenu.filter((item) => item !== null);
          return menu.subMenu.length > 0 ? menu : null;
        }

        return menu;
      })
      .filter((menu) => menu !== null);
  };

  useEffect(() => {
    const items = {
      [userRoleItems[0]]: admin,
      [userRoleItems[1]]: courier,
      [userRoleItems[2]]: customer,
    };
    setMenu(filterMenuItems(items[auth?.role || userRoleItems[2]]));
  }, [auth]);

  const renderMenu = (item) => {
    if (!!item.heading)
      return (
        <li key={item.heading} className="sidebar-menu-group-title">
          {item.heading}
        </li>
      );
    const linkUrl = `/${convertRoleToPath(auth.role)}${item.link || ""}`;

    if (!!item.text)
      return (
        <li key={item.link + item.text}>
          <NavLink
            to={linkUrl}
            end
            className={(navData) => (navData.isActive ? "active-page" : "")}
          >
            <Icon icon={item.icon} className="menu-icon" />
            <span className="w-75">{item.text}</span>
            {item.badge && (
              <Badge color={item.badgeColor || "info"} className="me-auto">
                {item.badge}
              </Badge>
            )}
          </NavLink>
        </li>
      );
  };

  return (
    <aside
      className={
        sidebarActive
          ? "sidebar active "
          : mobileMenu
            ? "sidebar sidebar-open"
            : "sidebar"
      }
    >
      <button
        onClick={mobileMenuControl}
        type="button"
        className="sidebar-close-btn"
      >
        <Icon icon="solar:close-circle-broken" className="text-xl" />
      </button>
      <div>
        <Link to="/" className="sidebar-logo">
          <img
            src="/assets/images/logo.jpg"
            alt="site logo"
            className="light-logo"
          />
          <img
            src="/assets/images/logo-light.png"
            alt="site logo"
            className="dark-logo"
          />
          <img
            src="/assets/images/logo-icon.png"
            alt="site logo"
            className="logo-icon"
          />
        </Link>
      </div>
      <div className="sidebar-menu-area">
        <ul className="sidebar-menu" id="sidebar-menu">
          {menu.map(renderMenu)}
        </ul>
      </div>
    </aside>
  );
};

export default Sidebar;
